import * as React from 'react'

const SvgChevronLeftIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.25 10l6.25-6.25.875.875L8 10l5.375 5.375-.875.875L6.25 10z"
      fill="#163250"
    />
  </svg>
)

export default SvgChevronLeftIcon
